<template>
  <div class="client-avatar py-1">
    <img :src="logo" alt="Colektia" class="mx-auto">
  </div>
</template>

<script>
export default {
  props: {
    companyId: {
      type: Number,
      default: 0,
    },
  },
  computed: {
    logo() {
      let src = '';
      if (this.companyId !== 17322821519) {
        src = `https://files.colektia.com/company_logos/${this.companyId}.png`;
      } else {
        src = `https://files.colektia.com/company_logos/${this.companyId}.svg`;
      }
      return src;
    },
  },
};
</script>

<style scoped>
  .client-avatar {
    width: 150px;
    height: 30px;
    border-radius: 5px;
    overflow: hidden;
    border: 1px solid #2C2C2C;
    text-align: center;
  }
  .client-avatar img {
    max-width: 100%;
    height: 100%;
    width: auto;
  }
</style>


// WEBPACK FOOTER //
// src/components/global/CompanyAvatar/CompanyAvatar.vue